import AmuletStackerPage from "components/pages/AmuletStackerPage/AmuletStackerPage"
import PageWrapper from "components/PageWrapper"
import { Route, Routes, BrowserRouter as Router } from "react-router-dom"
import BraceletStackerPage from "components/pages/BraceletStackerPage/BraceletStackerPage"

export function App(): JSX.Element {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<div>Select the page</div>} />
        <Route
          path="/testing/amulets"
          element={
            <PageWrapper bodyTheme="StackerPageBody" disableDefaultTheme={true}>
              <AmuletStackerPage />
            </PageWrapper>
          }
        />
        <Route
          path="/testing/bracelets"
          element={
            <PageWrapper bodyTheme="StackerPageBody" disableDefaultTheme={true}>
              <BraceletStackerPage />
            </PageWrapper>
          }
        />
      </Routes>
    </Router>
  )
}
